import GiftCardDetailsModal from './GiftCardDetailsModal';

export default GiftCardDetailsModal;
